import { createTheme } from "@mui/material/styles";

/**
 * Global MUI defaults. Tooltip defaults are overridden so plain `<Tooltip>` from MUI
 * uses white background and black text app-wide (unless a component overrides via `sx`).
 */
export const muiTheme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "#FFFFFF",
          color: "#000000",
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.15)",
          fontSize: "12px",
          fontFamily: "Cerebri Sans",
          padding:"10px",
          border:"1px solid #DEDEDE",
        },
        arrow: {
          color: "#FFFFFF",
        },
      },
    },
  },
});
